<onsip-loading-container
  [deferCond]="loadingStateComplete$"
  [loadingMessage]="'ONSIP_I18N.SAVING_CHANGES'"
>
  <form
    [formGroup]="formGroup"
    onsipFormTracking
    name="admin-voicemail-advanced-edit"
    id="admin-voicemail-advanced-edit"
    (ngSubmit)="onSubmit()"
  >
    <div onsip-grid-placement-shelf>
      <div class="first-column">
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Time zone</div>
          <mat-form-field appearance="outline">
            <mat-select formControlName="timezone">
              @for (tz of timeZones; track tz) {
              <mat-option [value]="tz[0]">
                {{ tz[1] }}
              </mat-option>
              }
            </mat-select>
          </mat-form-field>
        </section>
        <section>
          <mat-checkbox color="primary" formControlName="sayDateTime">
            On playback say date and time
          </mat-checkbox>
          <mat-checkbox color="primary" formControlName="sayDuration">
            On playback say message duration
          </mat-checkbox>
          <mat-checkbox color="primary" formControlName="sayCallerId">
            On playback say Caller ID
          </mat-checkbox>
        </section>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">
            {{ "ONSIP_I18N.PRESSING_ZERO_REDIRECTS_TO" | translate }}
          </div>
          <onsip-address-autocomplete
            formControlName="transferAddress"
            noneSelectedMessage="None"
            [customOptions]="customOptions"
          >
          </onsip-address-autocomplete>
        </section>
        <section class="with-mat-form-field">
          <div class="mat-body-1 m-b-12">Pager notification address</div>
          <mat-form-field appearance="outline">
            <input matInput formControlName="pagerNumber" />
            <mat-error>A pager must be in the email format; user&#64;domain</mat-error>
          </mat-form-field>
        </section>
      </div>
      <div class="second-column">
        <section class="with-mat-form-field">
          <div class="mat-subtitle-1">Voice mailbox applies to:</div>
          <div class="mat-body-1 m-b-12">SIP address</div>
          <onsip-sip-address-field #sipAddressField formControlName="sipAddressUsername">
          </onsip-sip-address-field>
        </section>
        <section>
          <div class="mat-body-1 m-b-12">{{ "ONSIP_I18N.EXTENSIONS" | translate }}</div>
          <onsip-extensions-list
            #extensionsList
            formControlName="extensionsList"
            [currentId]="voicemail.voicemailboxAddress?.addressId"
          >
          </onsip-extensions-list>
        </section>
      </div>
    </div>
    <div class="page-view-controls">
      <button mat-button type="button" (click)="togglePanel()" color="primary">
        {{ "ONSIP_I18N.CANCEL" | translate }}
      </button>
      <button
        mat-flat-button
        color="primary"
        type="submit"
        [attr.data-cy]="E2eLocators.ADMIN_VOICEMAIL_EDIT_ADVANCED_SETTINGS_SHELVE_SUBMIT"
      >
        {{ "ONSIP_I18N.SAVE_CHANGES" | translate }}
      </button>
    </div>
  </form>
</onsip-loading-container>
